// order matters as it defined the order of the sections in the page
/* eslint-disable sort-keys */

export const CONTENT_SECTIONS = {
  AWARD: 'award',
  HEADER: 'header',
  PROMOTIONS: 'promotions',
  OFFER_STRIP: 'offerStrip',
  PRODUCTS: 'productsByType',
  COVER_INCLUSIONS: 'coverInclusions',
  VALUE_PROPOSITIONS: 'valuePropositionGroup',
  HOW_IT_WORKS: 'howItWorks',
  CORE_BENEFITS: 'coreBenefits',
  RELEVANT_ADD_ONS: 'relevantAddOns',
  FEATURES_AND_BENEFITS: 'featuresAndBenefits',
  INCLUSIONS: 'inclusions',
  CONTACT_DETAILS: 'contactDetails',
  ADD_ONS: 'productConfigGroup',
  POPULAR_PRODUCTS: 'popularProducts',
  PRODUCT_LIST: 'productList',
  COMMON_QUESTIONS_ALTERNATE: 'commonQuestionsAlternate',
  TILES: 'tiles',
  FORMS_AND_GUIDES: 'formsAndGuides',
  COMMON_QUESTIONS: 'commonQuestions',
  QUICK_LINKS: 'quickLinks',
  CROSS_SELL: 'crossSell',
  ARTICLES: 'articles',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
} as const;

export const CMS_CONTENT_SECTIONS = {
  HEADER: 'brandCampaigns',
  PROMOTIONS: 'promotions',
  OFFER_STRIP: 'offer',
  VALUE_PROPOSITIONS: 'valuePropositionGroup',
  FEATURES_AND_BENEFITS: 'featuresAndBenefits',
  CONTACT_DETAILS: 'contactDetails',
  TILES: 'tiles',
  FORMS_AND_GUIDES: 'formsAndGuides',
  COMMON_QUESTIONS: 'questions',
  QUICK_LINKS: 'quickLinks',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  CROSS_SELL: 'crossSell',
  PRODUCTS: 'productsByType',
  ADD_ONS: 'productConfigGroup',
  COMMON_QUESTIONS_ALTERNATE: 'commonQuestions',
  RELEVANT_ADD_ONS: 'relevantAddOns',
  CORE_BENEFITS: 'coreBenefits',
  ARTICLES: 'articles',
  HOW_IT_WORKS: 'howTo',
};
